import { adminSupabase } from './supabase'

export async function waProxy<T = unknown>(
  path: string,
  method: 'GET' | 'POST' | 'DELETE' = 'GET',
  body?: object
): Promise<T> {
  const { data, error } = await adminSupabase.functions.invoke('whatsapp-proxy', {
    body: { path, method, body: body ?? null },
  })

  if (error) throw error
  return data as T
}
